module.exports = __webpack_public_path__ + "img/whatsapp_back_2.026b3833.png";